import { TFunction } from "react-i18next";

import { NotificationToast } from "../components/Generic/Toast/NotificationToast";
import { File as IFile } from "../models/file";

export const DEFAULT_ALLOWED_IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif"];

export const DEFAULT_MAX_FILE_SIZE = 8 * 1024 * 1024;

export interface FileValidationOptions {
  allowedExtensions?: string[];
  maxSize?: number;
}

export const fileIsValid = (
  translate: TFunction<"translation", undefined>,
  file?: IFile,
  options?: FileValidationOptions
): boolean => {
  const allowedExtensions = options?.allowedExtensions;
  const maxSize = options?.maxSize || DEFAULT_MAX_FILE_SIZE;

  if (allowedExtensions && allowedExtensions.length > 0 && file?.extension) {
    let someExtensionMatch = false;

    allowedExtensions.forEach((allowedExtension) => {
      if (allowedExtension === file?.extension) someExtensionMatch = true;
    });

    if (!someExtensionMatch) {
      NotificationToast.warning(translate("thisFileExtensionIsNotAllowed"));
      return false;
    }
  }

  if (file?.size && file.size > maxSize) {
    NotificationToast.warning(translate("fileIsTooBigMax8Mb"));
    return false;
  }

  return true;
};
